<template>
  <div class="wrapper" :style="cssProps">
    <div class="header">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content">
      <div class="label">
        <p class="text">PAY WITH CARD</p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["set_credit_card_info"] }}
      </p>
      <div id="payment-form">
        <div id="card-container">
          <div class="loading">
            <pulse-loader
              :color="'#af7c00'"
              :size="'2em'"
              :loading="loading"
            ></pulse-loader>
          </div>
        </div>
      </div>
      <div class="rest-text">
        {{ this.$store.getters.TRANSLATIONS["*rest_assured"] }}
        <br />{{ this.$store.getters.TRANSLATIONS["details_on_this_website"] }}
        <br />{{ this.$store.getters.TRANSLATIONS["stored_by_authorize"] }}
        <br />{{ this.$store.getters.TRANSLATIONS["payment_gateway"] }}
      </div>
      <div class="agree">
        <div class="agree-checkbox">
          <input type="checkbox" v-model="save" />
        </div>
        <div class="agree-text">
          <span class="g-text"> SAVE THE CARD FOR FUTURE PAYMENTS </span>
        </div>
      </div>
    </div>
    <div class="footer">
      <button v-on:click="addCard()" class="button" v-if="!loading2">
        PAY
      </button>
      <div class="loading">
        <pulse-loader
          :color="'#af7c00'"
          :size="'2em'"
          :loading="loading2"
        ></pulse-loader>
      </div>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: async function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    }
    if (!this.square) {
      throw new Error("Square.js failed to load properly");
    } else {
      await this.initWalletPayments();
    }
  },
  data() {
    return {
      loading: false,
      loading2: false,
      save: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),

      back: () => {
        if (this.$route.query.returnTo) {
          this.$router.push(`/${this.$route.query.returnTo}`);
        } else {
          this.$router.push("/selectPayment");
        }
      },
      icon: require("@/assets/icon_back.png"),
      // SquareUp manual card add logic
      appId: this.config.SQUARE.appId,
      locationId: this.config.SQUARE.locationId,
      payments: null,
      card: null,
      async initWalletPayments() {
        this.loading = true;
        try {
          this.payments = await this.square.payments(
            this.appId,
            this.locationId
          );
          console.log("payments");
          console.log(this.payments);
          this.card = await this.payments.card();
          await this.card.attach("#card-container");
          this.loading = false;
        } catch (e) {
          console.log("Error");
          console.log(e);
          return;
        }
      },
      async addCard() {
        this.loading2 = true;
        const tokenResult = await this.card.tokenize();
        console.log("AddCard token result:");
        console.log(tokenResult);

        if (tokenResult.token) {
          const body = {
            onDemandId: this.$store.getters.REQUESTED_VEHICLE_INFO.onDemandId,
            squareupPaymentToken: tokenResult.token,
            paymentCredit:
              this.$store.getters.TOTAL_AMOUNT -
              this.$store.getters.LAST_PARKING_TIP,
            tipCharge: this.$store.getters.LAST_PARKING_TIP,
            paymentType: "S2",
            squareUpLocationId: "LMS7GG8ZP79DM"
          };
          console.log("Digital wallet payment body:");
          console.log(body);
          this.$http
            .post(
              `${process.env.SERVER_URL}/8D69BBA6300F41AEA94119E133953688`,
              {
                payment: body
              },
              {
                headers: {
                  "x-access-token": this.$storage.get("parkendaToken"),
                  userid: -900
                }
              }
            )
            .then((response) => {
              console.log("Charge parking receipt response:");
              console.log(response);
              if (this.save) {
                this.$http
                  .post(
                    `${process.env.SERVER_URL}/942854760A354179AEA30A6C0767B45C`,
                    {
                      squareUptoken: response.data.paymentInfo.payment.id
                    },
                    {
                      headers: {
                        "x-access-token": this.$storage.get("parkendaToken")
                      }
                    }
                  )
                  .then((response) => {
                    console.log("Add card response");
                    console.log(response);
                    if (
                      response.data &&
                      response.status &&
                      response.status === 200
                    ) {
                      this.$router.push("/appRating?returnTo=paymentProcessed");
                    }
                  });
              } else {
                this.$router.push("/appRating?returnTo=paymentProcessed");
              }
            })
            .catch((error) => {
              let text =
                this.$store.getters.TRANSLATIONS["something_went_wrong"];
              if (
                error.response &&
                error.response.data &&
                error.response.data.error
              ) {
                text = error.response.data.error;
              }
              this.$modal.show("dialog", {
                text: this.$store.getters.TRANSLATIONS[
                  "payment_processing_failed"
                ],
                buttons: [
                  {
                    title: "Re-try",
                    handler: () => {
                      window.location.replace(
                        "/#/payWithSquareUpCreditCard?auto=1"
                      );
                      window.location.reload();
                    }
                  },
                  {
                    title: "Add Payment",
                    handler: () => {
                      this.$router.push(
                        "/cardAddSquare?returnTo=payWithSquareCreditCard"
                      );
                    }
                  }
                ]
              });
            })
            .finally(() => {
              this.loading2 = false;
            });
        } else {
          this.loading2 = false;
        }
      }
    };
  }
};
</script>

<style src="../../styles/main.css"></style>
<style scoped>
.v-spinner {
  padding: 43px;
  font-size: 10px;
}
.rest-text {
  color: gray;
  text-align: left;
  margin: 2vh auto;
  font-size: 3.5vw;
}
#payment-form {
  width: 80%;
  margin: 0 auto;
  background-color: #ffffff;
  height: 138px;
  padding: 35px 15px 0px 15px;
}
.agree-checkbox {
  width: 10%;
  margin-top: -2px;
}
.agree-checkbox input {
  margin: 0 0 0 0;
  background: transparent;
}
.agree {
  width: 79%;
  margin: 3vh 0 0 51px;
  display: inline-flex;
}
.agree-text {
  font-size: 12px;
}
.g-text {
  color: white;
  padding: 5px;
}
.g-text a {
  color: rgba(251, 174, 49, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/Cards/FastPaySquare.vue